// Landing hero "Google ranking" animation strings (merged into lp.rank).
const en = {
  lp: {
    rank: {
      example: "Example",
      you: "YOU",
      your_business: "Your business",
      pill: "Your customers play… you climb:",
      pill_first: "You're now #1 on Google",
      ordinal: { 1: "1st", 2: "2nd", 3: "3rd", 4: "4th" },
      via_game: "via a QRISE game",
      counter_label: "reviews, followers and likes generated for our brands",
      plays_label: "games played on our brands' contests",
      plays_detail: "real players, demos excluded",
      counter_breakdown: "{{reviews}} reviews · {{follows}} followers · {{likes}} likes",
      demo_btn: "Play the demo",
      demo_next: "Next up: {{game}} · a different game on every click",
      aria: "Animated example: a business climbs from 4th to 1st place in Google results thanks to player reviews",
      scenarios: {
        restaurant: {
          query: "restaurant near me",
          you: "Restaurant · € · 200 m",
          c: ["Creole · €€ · 350 m", "Burger · € · 600 m", "Pizzeria · €€ · 800 m"],
          hours: "Open · Closes 11pm",
          review: "Quick, delicious — and I won a dessert!",
        },
        shop: {
          query: "clothing store near me",
          you: "Fashion store · 150 m",
          c: ["Ready-to-wear · 300 m", "Streetwear · 550 m", "Concept store · 900 m"],
          hours: "Open · Closes 7pm",
          review: "Lovely welcome, and I won 10% off on the wheel!",
        },
        garage: {
          query: "car garage near me",
          you: "Car repair · 400 m",
          c: ["Car repair · 700 m", "Mechanics · 1.2 km", "Tyres & servicing · 2 km"],
          hours: "Open · Closes 6pm",
          review: "Spotless work, and a free oil change from the game!",
        },
      },
    },
  },
};

const fr = {
  lp: {
    rank: {
      example: "Exemple",
      you: "VOUS",
      your_business: "Votre commerce",
      pill: "Vos clients jouent… vous montez :",
      pill_first: "Vous passez 1er sur Google",
      ordinal: { 1: "1er", 2: "2e", 3: "3e", 4: "4e" },
      via_game: "via un jeu QRISE",
      counter_label: "avis, abonnés et likes générés pour nos enseignes",
      plays_label: "participations aux jeux de nos enseignes",
      plays_detail: "vrais joueurs, hors démos",
      counter_breakdown: "{{reviews}} avis · {{follows}} abonnés · {{likes}} likes",
      demo_btn: "Jouer à la démo",
      demo_next: "Prochain : {{game}} · un jeu différent à chaque clic",
      aria: "Exemple animé : un commerce passe de la 4e à la 1re place sur Google grâce aux avis des joueurs",
      scenarios: {
        restaurant: {
          query: "restaurant près de moi",
          you: "Restaurant · € · 200 m",
          c: ["Créole · €€ · 350 m", "Burger · € · 600 m", "Pizzeria · €€ · 800 m"],
          hours: "Ouvert · Ferme à 23:00",
          review: "Rapide, délicieux, et j'ai gagné un dessert !",
        },
        shop: {
          query: "boutique de mode près de moi",
          you: "Boutique de mode · 150 m",
          c: ["Prêt-à-porter · 300 m", "Streetwear · 550 m", "Concept store · 900 m"],
          hours: "Ouvert · Ferme à 19:00",
          review: "Super accueil, et -10 % gagné à la roue !",
        },
        garage: {
          query: "garage auto près de moi",
          you: "Garage automobile · 400 m",
          c: ["Garage automobile · 700 m", "Mécanique · 1,2 km", "Pneus & entretien · 2 km"],
          hours: "Ouvert · Ferme à 18:00",
          review: "Travail nickel, et une vidange offerte au jeu !",
        },
      },
    },
  },
};

const rankResources = { en, fr };
export default rankResources;
